import { render, staticRenderFns } from "./shopStyle.vue?vue&type=template&id=b8701ec8&scoped=true&"
import script from "./shopStyle.vue?vue&type=script&lang=js&"
export * from "./shopStyle.vue?vue&type=script&lang=js&"
import style0 from "./shopStyle.vue?vue&type=style&index=0&id=b8701ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8701ec8",
  null
  
)

export default component.exports